import classNames from 'classnames';
import * as React from 'react';
import throttle from 'lodash/throttle';
import { useImperativeHandle, useRef, useState } from 'react';
import { ConfigContext } from '../config-provider';
import useBuriedPoint from '../_util/hooks/useBuriedPoint';
import Sidebar from './side-bar';
import { traverseReactNode } from './utils';
import { Panel } from './panel';
const IndexBar = React.forwardRef((props, ref) => {
    const { getPrefixCls } = React.useContext(ConfigContext);
    const bodyRef = useRef(null);
    useBuriedPoint('index-bar');
    const { prefixCls: customizePrefixCls, className, children } = props;
    const prefixCls = getPrefixCls('index-bar', customizePrefixCls);
    const classString = classNames(prefixCls, {
        [`${prefixCls}-sticky`]: props.sticky,
    }, className);
    const indexItems = [];
    const panels = [];
    traverseReactNode(children, (child) => {
        var _a;
        if (!React.isValidElement(child))
            return;
        if (child.type !== Panel) {
            console.warn('The children of `IndexBar` must be `IndexBar.Panel` components.');
        }
        indexItems.push({
            index: child.props.index,
            brief: (_a = child.props.brief) !== null && _a !== void 0 ? _a : child.props.index.charAt(0),
        });
        panels.push(React.createElement("div", { key: child.props.index, "data-index": child.props.index, className: `${prefixCls}-anchor` },
            React.createElement("div", { className: `${prefixCls}-anchor-title` }, child.props.title || child.props.index),
            React.createElement("div", { className: `${prefixCls}-anchor-children` }, child.props.children)));
    });
    useImperativeHandle(ref, () => ({ scrollTo }));
    // 滑动到某个字母
    function scrollTo(index) {
        var _a;
        const body = bodyRef.current;
        if (!body)
            return;
        const children = body.children;
        for (let i = 0; i < children.length; i++) {
            const panel = children.item(i);
            if (!panel)
                continue;
            const panelIndex = panel.dataset['index'];
            if (panelIndex === index) {
                body.scrollTop = panel.offsetTop;
                setActiveIndex(index);
                activeIndex !== index && ((_a = props.onIndexChange) === null || _a === void 0 ? void 0 : _a.call(props, index));
                return;
            }
        }
    }
    const [activeIndex, setActiveIndex] = useState(() => {
        const firstItem = indexItems[0];
        return firstItem ? firstItem.index : null;
    });
    const titleHeight = 36;
    const checkActiveScroll = throttle(() => {
        var _a;
        const body = bodyRef.current;
        if (!body)
            return;
        const scrollTop = body.scrollTop;
        const elements = body.getElementsByClassName(`${prefixCls}-anchor`);
        for (let i = 0; i < elements.length; i++) {
            const panel = elements.item(i);
            if (!panel)
                return;
            const panelIndex = panel.dataset['index'];
            if (!panelIndex)
                continue;
            if (panel.offsetTop + panel.clientHeight - titleHeight > scrollTop) {
                setActiveIndex(panelIndex);
                activeIndex !== panelIndex && ((_a = props.onIndexChange) === null || _a === void 0 ? void 0 : _a.call(props, panelIndex));
                return;
            }
        }
    }, 50);
    return (React.createElement("div", { className: classString },
        React.createElement(Sidebar, { indexItems: indexItems, activeIndex: activeIndex, onActive: (index) => {
                scrollTo(index);
            } }),
        React.createElement("div", { className: `${prefixCls}-body`, ref: bodyRef, onScroll: checkActiveScroll }, panels)));
});
IndexBar.defaultProps = {
    sticky: true,
};
export default IndexBar;
